@if (crosswordGame) {
  <div class="flex-row align-center-end-row" style="gap: 5px">
    <app-toggle-show-crossword [handleCrosswordView]="gameHandleCrosswordView"></app-toggle-show-crossword>
    @if (crosswordActionButtons != null) {
      <app-flexable-button-menu fxFlex [buttons]="crosswordActionButtons" [keepOrder]="true"> </app-flexable-button-menu>
    }
  </div>
}
